export default function () {
  return {
    id: "legendMargin",
    beforeInit(chart: any, args: any, options: any) {
      const fitValue = chart.legend.fit;
      chart.legend.fit = function fit() {
        fitValue.bind(chart.legend)();
        return (this.height += 10);
      };
    },
  };
}
